module.exports = __webpack_public_path__ + "static/media/8-10.225ea5c0.mp3";